 
<template>
  <!--expand-on-hover-->
  <v-navigation-drawer
 
    v-model="drawer"
    :rail="rail"
    
    permanent
    style="  padding:0px!important;"
  >
    <!-- User header -->
    <v-list>
      <v-list-item>
        <template #prepend>
          <!-- 
          <v-img :src="logo" width="24" height="24" class="mr-2" />{{ userName }}
            -->
 
          <div style="
          border:2px solid rgb(var(--v-theme-on-surface));
          padding:3px 3px 1px 7px; 
          line-height: 1.3;
          
          font-size:11px;
          margin-left:-6px;
          font-weight:900!important;
          letter-spacing: 3px;
          color: rgb(var(--v-theme-on-surface))
          
          ">
            LW<br>
            YR
          </div>

          <!--
          <div style="
          border:2px solid white; 
          padding:1px 3px 1px 7px; 
          line-height: 1.3;
          font-style: arial;
          font-size:25px;
          margin-left:-6px;
          font-weight:bold;
          letter-spacing: 3px;

          
          ">
            LWYR
          </div>
          -->

         
              <v-list-item-title class="side-nav-title" style="font-size:12px; margin-left:37px; font-weight: bold;">LWYR</v-list-item-title>
           

          <!-- <p style="padding-left:30px">{{ userName }}</p>-->
          
        </template>

        <!-- 
        <template #append>

          <v-btn
         
            variant="text"
            @click.stop="rail = !rail"
          >
         <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z"/></svg>
        </v-btn>
        </template>-->
      </v-list-item>
    </v-list>

    <v-divider />

    <!-- Navigation -->
    <v-list density="compact" nav style=" ">

    <!--
      <v-list-item prepend-icon="mdi-home-city" title="Home" to="/" router />
      <v-list-item prepend-icon="mdi-account" title="My Account" to="/account" router />
      <v-list-item prepend-icon="mdi-account-group-outline" title="Users" to="/users" router />
      
      <v-icon size="24" class="mr-2">
      -->

 
   
        <v-list-item to="/" router>
            <template #prepend style="">
              
              <v-icon 
              style="margin:auto; 
              text-align: center;" 
              class="nav-bottom-btn-icon mr-2 " 
              size="24"
               
              >
              mdi-view-dashboard-outline
            </v-icon>  
            </template>
            <v-list-item-title class="side-nav-title">Home</v-list-item-title>
        </v-list-item>

        <v-list-item to="/daily" router>
            <template #prepend>
              <v-icon class="nav-bottom-btn-icon mr-2" size="24">mdi-newspaper-variant-outline</v-icon>  
            </template>
            <v-list-item-title class="side-nav-title">Daily Briefing</v-list-item-title>
        </v-list-item>

        <v-list-item to="/trending" router>
            <template #prepend>
              <v-icon class="nav-bottom-btn-icon mr-2" size="24">mdi-trending-up</v-icon>  
            </template>
            <v-list-item-title class="side-nav-title">Trending</v-list-item-title>
        </v-list-item>

        <v-list-item to="/journals/ohlj" router style="">
            <template #prepend>
              <v-icon class="nav-bottom-btn-icon mr-2" size="24">mdi-notebook-outline</v-icon>  
            </template>
            <v-list-item-title class="side-nav-title">Journals</v-list-item-title>
        </v-list-item>



        <v-list-item to="/search" router>
            <template #prepend>
              <v-icon class="nav-bottom-btn-icon mr-2" size="24">mdi-magnify</v-icon>  
              
            </template>
            <v-list-item-title class="side-nav-title">Search</v-list-item-title>
        </v-list-item>
 
        <v-list-item to="/favorites" router>
            <template #prepend>
              <v-icon class="nav-bottom-btn-icon mr-2" size="24">mdi-bookmark-box-outline</v-icon>  
            </template>
            <v-list-item-title class="side-nav-title">Bookmarks</v-list-item-title>
        </v-list-item>

        <v-list-item to="/history" router>
            <template #prepend>
               <v-icon class="nav-bottom-btn-icon mr-2" size="24">mdi-history</v-icon>  
            </template>
            <v-list-item-title class="side-nav-title">Viewed</v-list-item-title>
        </v-list-item>















          <v-list-item
            :to="{ path: '/settings', query: { section: 'topics' } }"
            link
             exact
          >
              <template #prepend>
            
                  <v-icon class="nav-bottom-btn-icon mr-2" size="24">mdi-filter-outline</v-icon>  
              </template>
              <v-list-item-title class="side-nav-title">Filters</v-list-item-title>
          </v-list-item>

          <!-- 
          <v-list-item style=
            :to="{ path: '/settings', query: { section: 'topics' } }"
            link
            exact
          >
              <template #prepend>
            
                  <v-icon class="nav-bottom-btn-icon mr-2" size="24">mdi-tag-multiple-outline</v-icon>  
              </template>
              <v-list-item-title class="side-nav-title">Filter Topics</v-list-item-title>
          </v-list-item>

        -->


          <v-list-item
            :to="{ path: '/settings', query: { section: 'about' } }"
            link
            exact
          >
            <template #prepend>
          
                <v-icon class="nav-bottom-btn-icon mr-2" size="24">mdi-cog-outline</v-icon>  
            </template>
            <v-list-item-title class="side-nav-title">Settings</v-list-item-title>
          </v-list-item>




          <v-list-item
            to="/admin"
            link
            v-if="isAdmin"
          >
            <template #prepend>
          
                <v-icon class="nav-bottom-btn-icon mr-2" size="24">mdi-shield-crown-outline</v-icon>  
            </template>
            <v-list-item-title class="side-nav-title">Admin</v-list-item-title>
          </v-list-item>





















 
    </v-list>

    <template v-slot:append>

      <v-list density="compact" >


        <v-list-item 
        
        @click="toggleRail"
        >
            <template #prepend>
              <v-icon class="nav-bottom-btn-icon mr-2" size="24" >mdi-arrow-expand-horizontal</v-icon>
            </template>
            <v-list-item-title class="side-nav-title">Hide Sidebar</v-list-item-title>
        </v-list-item>



       <v-list-item  @click="toggleTheme">
            <template #prepend>
              <v-icon class="nav-bottom-btn-icon mr-2" size="24">mdi-theme-light-dark</v-icon>
            </template>
            <v-list-item-title class="side-nav-title">Dark / Light</v-list-item-title>
        </v-list-item>





        <v-list-item   @click="onSignOut" class="logout-btn">
            <template #prepend>
              <v-icon class="nav-bottom-btn-icon mr-2" size="24">mdi-power</v-icon>
            </template>
            <v-list-item-title class="side-nav-title">Logout</v-list-item-title>
        </v-list-item>


      </v-list>
    </template>
  </v-navigation-drawer>

 
  <!-- Journals sub-nav — only shown while browsing a journal -->
  <v-navigation-drawer
    permanent
    class="border-s"
    v-if="route.path.startsWith('/journals')"
  >
<!--v-theme-on-surface
ohlj → Osgoode Hall Law Journal
ubclr → UBC Law Review
trulr → TRU Law Review
mcgilllj → McGill Law Journal
utorontolj → U of T Law Journal
albertalr → Alberta Law Review
dalhousielj → Dalhousie Law Journal
appeal → UVic (exception — official name)
https://journals.uvic.ca/index.php/appeal/issue/archive
https://albertalawreview.com/index.php/ALR/issue/archive
-->



        <v-list density="compact" nav color="accent">

          <v-list-subheader class="side-nav-title">Journals</v-list-subheader>

          <v-list-item :to="`/journals/ohlj`" router>
              <template #prepend>
                <v-icon class="nav-bottom-btn-icon mr-2" size="24">mdi-book-open-page-variant-outline</v-icon>
              </template>
              <v-list-item-title class="side-nav-title">Osgoode Hall Law Journal</v-list-item-title>
          </v-list-item>


          <v-list-item :to="`/journals/trulr`" router>
              <template #prepend>
                <v-icon class="nav-bottom-btn-icon mr-2" size="24">mdi-book-open-page-variant-outline</v-icon>
              </template>
              <v-list-item-title class="side-nav-title">TRU Law Review</v-list-item-title>
          </v-list-item>



          <v-list-item :to="`/journals/ubclr`" router>
              <template #prepend>
                <v-icon class="nav-bottom-btn-icon mr-2" size="24">mdi-book-open-page-variant-outline</v-icon>
              </template>
              <v-list-item-title class="side-nav-title">UBC Law Review</v-list-item-title>
          </v-list-item>


          <v-list-item :to="`/journals/uvicappeal`" router>
              <template #prepend>
                <v-icon class="nav-bottom-btn-icon mr-2" size="24">mdi-book-open-page-variant-outline</v-icon>
              </template>
              <v-list-item-title class="side-nav-title">UVic Appeal</v-list-item-title>
          </v-list-item>




        </v-list>
  </v-navigation-drawer>
 


  
</template>



















<script setup>
import { ref } from "vue"
import logo from '@/assets/logo.png'

import { useRoute } from 'vue-router'

// Admin status
import { isAdmin } from "@/store/authStore"


console.log('isAdmin ', isAdmin.value)







const drawer = ref(true)
const rail = ref(true)



const route = useRoute()

defineProps({
  onSignOut: {
    type: Function,
    required: true
  },
  userName: { type: String, default: '' } 
})








import { useTheme } from 'vuetify';
import { watch } from 'vue';

const theme = useTheme();



const toggleTheme = () => {
  theme.global.name.value =
    theme.global.name.value === 'dark' ? 'light' : 'dark';
};
watch(
  () => theme.global.name.value,
  v => localStorage.setItem('theme', v)
);
theme.global.name.value = localStorage.getItem('theme') || 'light';



const toggleRail = () => {
 
  rail.value = !rail.value;
  localStorage.setItem('rail', rail.value);
 

  //@click="rail = false"
  //theme.global.name.value =
  //    theme.global.name.value === 'dark' ? 'light' : 'dark';
};
rail.value = localStorage.getItem('rail') === 'true';

</script>













<style scoped>
:deep(.v-navigation-drawer) {
  height: 100vh; /* force full height */
}
.side-nav-title{
   
    text-align: left!important;
    padding-left:0!important;
    font-size: 13px!important;
    font-weight: 400!important;
}

.logout-btn {



}

/* Bold the active journal link — v-list's color prop already tints it,
   but color alone is easy to miss against similar-looking sibling links. */
:deep(.v-list-item--active .side-nav-title) {
  font-weight: 700;
}
</style>


